import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doJoinClass),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doLeaveClass),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doSendHeartrate),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doTrackDevice),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(doUpdateClientStatus),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(watchBluetooth);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { select, all, takeEvery, call, fork, put } from 'redux-saga/effects';
import { fitnessDeviceTracking, leaderboardJoinClass, leaderboardLeaveClass, leaderboardUpdateHeartrate, leaderboardUpdateClientStatus, userProfile } from 'redux/saga/entities/bound';
import BLUETOOTH_STATUS from 'constants/bluetooth';
import { updateDevice } from 'redux/modules/video';
import { initPusherChannel } from 'features/VideoDetail/sagas/pusher.saga';
import { errorActionCreator } from 'redux/saga/helpers';
import { leaderboardJoin, videoCompleted } from 'redux/saga/selectors/videos';
import { ec } from 'helpers/multitrack';
export var JOIN_CLASS = 'JOIN_CLASS';
export var LEAVE_CLASS = 'LEAVE_CLASS';
export var SEND_HEARTRATE = 'SEND_HEARTRATE';
export var BLUETOOTH_DEVICE_ERROR = 'BLUETOOTH_DEVICE_ERROR';
export var TRACK_DEVICE_INFO = 'TRACK_DEVICE_INFO';
export var UPDATE_CLIENT_STATUS = 'UPDATE_CLIENT_STATUS';
export var joinClass = function joinClass(alias, userMode) {
  return {
    type: JOIN_CLASS,
    alias: alias,
    userMode: userMode
  };
};
export var leaveClass = function leaveClass(alias) {
  return {
    type: LEAVE_CLASS,
    alias: alias
  };
};
export var sendHeartrate = function sendHeartrate(bpm, classId, playhead) {
  return {
    type: SEND_HEARTRATE,
    bpm: bpm,
    classId: classId,
    playhead: playhead
  };
};
export var trackDevice = function trackDevice(payload) {
  return {
    type: TRACK_DEVICE_INFO,
    payload: payload
  };
};
export var updateClientStatus = function updateClientStatus(alias, status) {
  return {
    type: UPDATE_CLIENT_STATUS,
    alias: alias,
    status: status
  };
};
export var loadBluetoothError = errorActionCreator.bind(null, BLUETOOTH_DEVICE_ERROR);
export function doJoinClass(client, _ref) {
  var alias, _ref$userMode, userMode, _ref2, _ref3, user, join;

  return regeneratorRuntime.wrap(function doJoinClass$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          alias = _ref.alias, _ref$userMode = _ref.userMode, userMode = _ref$userMode === void 0 ? 'INTERACTIVE' : _ref$userMode;
          _context.prev = 1;
          _context.next = 4;
          return all([call(fetchEntityIfNeeded, userProfile, [client])].concat(_toConsumableArray(userMode !== 'NON_INTERACTIVE' ? [put(updateDevice({
            enabled: true,
            status: BLUETOOTH_STATUS.DEVICE_CONNECTED
          }))] : [])));

        case 4:
          _ref2 = _context.sent;
          _ref3 = _slicedToArray(_ref2, 1);
          user = _ref3[0];
          _context.next = 9;
          return call(fetchEntity, leaderboardJoinClass, [client, alias, {
            user_id: user.id,
            user_mode: ['INTERACTIVE', 'NON_INTERACTIVE'].indexOf(userMode) > -1 ? userMode : 'NON_INTERACTIVE'
          }]);

        case 9:
          join = _context.sent;
          _context.next = 12;
          return put(initPusherChannel(join.configuration.channel_name));

        case 12:
          _context.next = 14;
          return call(ec, 'Leaderboard activity', {
            description: 'join class'
          });

        case 14:
          _context.next = 22;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](1);
          _context.next = 20;
          return call(ec, 'Leaderboard error', {
            description: 'failed to join class',
            error: _context.t0
          });

        case 20:
          _context.next = 22;
          return put(updateDevice({
            status: BLUETOOTH_STATUS.DEVICE_FAILED
          }));

        case 22:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 16]]);
}
export function doLeaveClass(client, _ref4) {
  var alias, user;
  return regeneratorRuntime.wrap(function doLeaveClass$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          alias = _ref4.alias;
          _context2.prev = 1;
          _context2.next = 4;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 4:
          user = _context2.sent;
          _context2.next = 7;
          return call(fetchEntity, leaderboardLeaveClass, [client, alias, {
            user_id: user.id
          }]);

        case 7:
          _context2.next = 9;
          return call(ec, 'Leaderboard activity', {
            description: 'leave class'
          });

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 15;
          return call(ec, 'Leaderboard error', {
            description: 'failed to leave class',
            error: _context2.t0
          });

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}
export function doSendHeartrate(client, _ref5) {
  var bpm, classId, playhead, joined, classEnded, _ref6, _ref6$calories, calories, disconnected, heart_rate, max_heart_rate, points;

  return regeneratorRuntime.wrap(function doSendHeartrate$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          bpm = _ref5.bpm, classId = _ref5.classId, playhead = _ref5.playhead;
          _context3.prev = 1;
          _context3.next = 4;
          return select(leaderboardJoin, classId);

        case 4:
          joined = _context3.sent;
          _context3.next = 7;
          return select(videoCompleted);

        case 7:
          classEnded = _context3.sent;

          if (!(joined && !classEnded)) {
            _context3.next = 22;
            break;
          }

          _context3.next = 11;
          return call(fetchEntity, leaderboardUpdateHeartrate, [client, classId, {
            heart_rate: bpm,
            playhead_time: playhead
          }]);

        case 11:
          _ref6 = _context3.sent;
          _ref6$calories = _ref6.calories;
          calories = _ref6$calories === void 0 ? 0 : _ref6$calories;
          disconnected = _ref6.disconnected;
          heart_rate = _ref6.heart_rate;
          max_heart_rate = _ref6.max_heart_rate;
          points = _ref6.points;
          _context3.next = 20;
          return put(updateDevice({
            bpm: joined ? heart_rate : bpm,
            bpmPercent: heart_rate / (max_heart_rate || 190) * 100,
            calories: calories,
            disconnected: disconnected,
            points: parseInt(points, 10)
          }));

        case 20:
          _context3.next = 24;
          break;

        case 22:
          _context3.next = 24;
          return put(updateDevice({
            bpm: bpm
          }));

        case 24:
          _context3.next = 30;
          break;

        case 26:
          _context3.prev = 26;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 30;
          return call(ec, 'Leaderboard error', {
            description: 'failed to patch heart rate',
            error: _context3.t0
          });

        case 30:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 26]]);
}
export function doTrackDevice(client, _ref7) {
  var payload;
  return regeneratorRuntime.wrap(function doTrackDevice$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref7.payload;
          _context4.prev = 1;
          _context4.next = 4;
          return all([call(fetchEntity, fitnessDeviceTracking, [client, payload]), put(updateDevice({
            connection: payload.device_name
          }))]);

        case 4:
          _context4.next = 10;
          break;

        case 6:
          _context4.prev = 6;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 10;
          return put(loadBluetoothError(_context4.t0));

        case 10:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 6]]);
}
export function doUpdateClientStatus(client, _ref8) {
  var alias, status;
  return regeneratorRuntime.wrap(function doUpdateClientStatus$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          alias = _ref8.alias, status = _ref8.status;
          _context5.prev = 1;
          _context5.next = 4;
          return call(fetchEntity, leaderboardUpdateClientStatus, [client, alias, {
            event_name: status,
            platform: 'web'
          }]);

        case 4:
          _context5.next = 10;
          break;

        case 6:
          _context5.prev = 6;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 10;
          return put(loadBluetoothError(_context5.t0));

        case 10:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 6]]);
}
export function watchBluetooth(client) {
  return regeneratorRuntime.wrap(function watchBluetooth$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return fork(takeEvery, JOIN_CLASS, doJoinClass, client);

        case 2:
          _context6.next = 4;
          return fork(takeEvery, LEAVE_CLASS, doLeaveClass, client);

        case 4:
          _context6.next = 6;
          return fork(takeEvery, SEND_HEARTRATE, doSendHeartrate, client);

        case 6:
          _context6.next = 8;
          return fork(takeEvery, TRACK_DEVICE_INFO, doTrackDevice, client);

        case 8:
          _context6.next = 10;
          return fork(takeEvery, UPDATE_CLIENT_STATUS, doUpdateClientStatus, client);

        case 10:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}